module.exports = __webpack_public_path__ + "static/img/61aae279c6521861aab7e26a482246c2.2e197b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61aae279c6521861aab7e26a482246c2.jpg
// module id = 3Oof
// module chunks = 4